import { MutableRefObject, useEffect, useContext, useRef } from "react";
import { MapContext } from "providers/MapProvider";

export type Autocomplete = google.maps.places.Autocomplete;

type Props = {
  referenceBinding: MutableRefObject<HTMLInputElement | null>;
  onInitialized: (autocomplete: Autocomplete) => void;
  onPlaceChange: (autocomplete: Autocomplete) => void;
};

type ReturnType = void;

const useAutocomplete = ({
  referenceBinding,
  onInitialized,
  onPlaceChange,
}: Props): ReturnType => {
  const { initialized, mapsLibraries } = useContext(MapContext);
  const onInitializedRef = useRef(onInitialized);
  const onPlaceChangeRef = useRef(onPlaceChange);

  onInitializedRef.current = onInitialized;
  onPlaceChangeRef.current = onPlaceChange;

  useEffect(() => {
    if (!(initialized && mapsLibraries && referenceBinding?.current)) {
      return;
    }
    const autocomplete = new mapsLibraries.places.Autocomplete(
      referenceBinding.current
    );
    onInitializedRef.current(autocomplete);

    const listener = autocomplete.addListener("place_changed", () =>
      onPlaceChangeRef.current(autocomplete)
    );

    return () => {
      listener.remove();
    };
  }, [initialized, mapsLibraries, referenceBinding]);
};

export default useAutocomplete;
